import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import useSnapState from '../../../hooks/useSnapState';

export default function createMainTimeline({
  firstLeafRowRef,
  mainElementTriggerRef,
  secondLeafRowRef,
}) {
  gsap.registerPlugin(ScrollTrigger);

  const isSnapActive = useSnapState();

  let scrollTriggerParams = {};

  if (isSnapActive) {
    scrollTriggerParams.scroller = `#container-snap-scroller`;
  }

  const tl = gsap.timeline({
    id: 'leaf-media-enter',
    scrollTrigger: {
      trigger: mainElementTriggerRef.current,
      start: 'top center',
      ...scrollTriggerParams,
    },
    repeatRefresh: true,
  });

  tl.add(animateLeafCardRow(firstLeafRowRef))
    .add(animateLeafCardRow(secondLeafRowRef), '<60%')
    .add(animateBackgroundImage(mainElementTriggerRef), '<-20%');

  return tl;
}

const animateBackgroundImage = (mainElementTriggerRef) => {
  const tl = gsap.timeline({ id: 'animateBackgroundImage' });

  tl.from(mainElementTriggerRef.current, {
    backgroundPositionY: '20rem',
    duration: 1.5,
    ease: 'ease-in',
  });

  return tl;
};

const animateLeafCardRow = (firstLeafRowRef) => {
  const tl = gsap.timeline({ id: 'animateLeafCardRow' });

  tl.from(
    firstLeafRowRef.current.getElementsByClassName('image-shapes__item')[0],
    {
      y: 200,
      opacity: 0,
      duration: 0.5,
      ease: 'ease-in',
    },
  ).from(
    firstLeafRowRef.current.getElementsByClassName('image-shapes__item')[1],
    {
      y: 400,
      opacity: 0,
      duration: 1,
      ease: 'ease-out',
    },
    '<50%',
  );

  return tl;
};
